import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { MESSAGE_MAX_LENGTH, MESSAGE_VARIANTS } from '../prospectOptions';
import { DEFAULT_TEMPLATES, TEMPLATE_TOKENS, loadTemplates, saveTemplates } from '../messageTemplates';

/**
 * ProspectTemplatesDialog - Edita os textos das versões (as duas do teste A/B e o
 * Retorno). Ficam salvos neste navegador e valem para o envio um a um e para o lote.
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Function} props.onSaved
 * @param {Function} props.onCancel
 */
function ProspectTemplatesDialog({ isOpen, onSaved, onCancel }) {
  const [texts, setTexts] = useState(DEFAULT_TEMPLATES);

  useEffect(() => {
    if (isOpen) setTexts(loadTemplates());
  }, [isOpen]);

  const setText = (key, value) => setTexts((prev) => ({ ...prev, [key]: value }));

  const handleSave = () => {
    saveTemplates(texts);
    onSaved();
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Textos das mensagens"
      variant="info"
      confirmLabel="Salvar textos"
      cancelLabel="Cancelar"
      onConfirm={handleSave}
      onCancel={onCancel}
      confirmDisabled={MESSAGE_VARIANTS.some((item) => !String(texts[item.value] || '').trim())}
      maxWidth={1200}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxHeight: '75vh', overflowY: 'auto', pr: 0.5, pt: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          Ficam salvos neste navegador. Variáveis que se ajustam a cada contato:{' '}
          {TEMPLATE_TOKENS.map((item, index) => (
            <Box component="span" key={item.token}>
              {index > 0 && ' · '}<strong>{item.token}</strong> {item.label}
            </Box>
          ))}
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
          {MESSAGE_VARIANTS.map((item) => (
            <Box key={item.value}>
              <TextField
                label={item.label}
                value={texts[item.value]}
                onChange={(e) => setText(item.value, e.target.value)}
                fullWidth
                multiline
                rows={12}
                inputProps={{ maxLength: MESSAGE_MAX_LENGTH }}
                sx={{ '& textarea': { fontSize: '0.9rem', lineHeight: 1.55 } }}
              />
              <Button
                size="small"
                onClick={() => setText(item.value, DEFAULT_TEMPLATES[item.value])}
                disabled={texts[item.value] === DEFAULT_TEMPLATES[item.value]}
                sx={{ textTransform: 'none', fontWeight: 600, px: 0, mt: 0.5 }}
              >
                Voltar ao texto padrão
              </Button>
            </Box>
          ))}
        </Box>
      </Box>
    </ConfirmDialog>
  );
}

export default ProspectTemplatesDialog;
